import { FilterRoute } from '../filter';
import { Invoice } from '../invoice';

export interface PaymentsRequest {
  endDate?: string;
  startDate?: string;
  pageNo?: number;
  pageSize?: number;
  sellerWorkspaceId: string;
  includeSettlement?: boolean;
  inviteIds?: string;
  searchKey?: string;
  docType?: string;
}

export interface PaymentsResponse {
  payments: Payment[];
  total: number;
  startRecord: number;
  endRecord: number;
  statusCode: number;
  responseStatus: string;
}

export interface Payment {
  id: string;
  paymentRequestId: any;
  customerName: string;
  customerCode: string;
  paymentDate: string;
  paymentRefCode: string;
  amountPaid: number;
  paymentType: string;
  paymentMode: string;
  upiId: string;
  inviteId: string;
  sellerWorkspaceId: string;
  buyerWorkspaceId: string;
  status: string;
  subStatus: any;
  createdDate: string;
  updatedDate: string;
  currencyCode: string;
  instrumentNumber?: string;
  instrumentDate: any;
  bankName: string;
  bankAccountNumber: string;
  bankReference?: string;
  referenceTransactionNumber: any;
  narration: string;
  teamMemberId: any;
  teamMemberName: string;
  source: string;
  invoices: any[];
  doctype: string;
}

export interface PaymentFilterRequest {
  sellerWorkspaceId: string;
  startDate?: string;
  endDate?: string;
  needCustomers?: boolean;
  route?: FilterRoute;
}

export interface PaymentFilterResponse {
  status: string[];
  docType: string[];
  paymentMode: string[];
  inviteIds: { id: string; name: string }[];
  statusCode: number;
  responseStatus: string;
}

export interface PaymentDetailsByiIdRequest {
  paymentId: string;
  includeSettlement: boolean;
  workspaceId: string;
  sellerWorkspaceId?: string;
}

export enum PaymentDoctypeEnum {
  PAYMENT = 'PYMNT',
  CREDIT_NOTE = 'CN',
}

export enum PaymentModeEnum {
  CHEQUE = 'CHQ',
  DEMAND_DRAFT = 'DD',
  BANK_TRANSFER = 'BNTR',
  ONLINE = 'ONLINE',
  CASH = 'CASH',
  UPI = 'UPI',
  WALLET = 'WALLET',
  NET_BANKING = 'NET_BANKING',
  CREDIT_CARD = 'CREDIT_CARD',
  TRANSFER = 'TF',
  CREDIT_NOTE = 'CN',
}

export interface PaymentDetailsByiIdResponse {
  id: string;
  createdDate: string;
  updatedDate: string;
  sellerWorkspaceId: string;
  buyerWorkspaceId: string;
  inviteId: string;
  paymentDate: string;
  amountPaid: number;
  allocatedAmount: number;
  currencyCode: string;
  status: string;
  subStatus: string;
  paymentType: string;
  paymentMode: string;
  paymentProvider: string;
  proofOfPayment: string;
  approvedBy: string;
  createdBy: string;
  paymentRefCode: string;
  instrumentNumber: string;
  instrumentDate: string;
  bankName: string;
  bankAccountNumber: string;
  bankReference: string;
  channel: string;
  cardNumber: string;
  cardNetwork: string;
  cardType: string;
  bankCode: string;
  upiId: string;
  narration: string;
  source: string;
  isAllocated: boolean;
  teamMemberId: string;
  paymentInvoiceMap: PaymentInvoiceMap[];
  paymentSettleMent: any;
  teamMemberName: string;
  statusCode: number;
  responseStatus: string;
  clearingDate: string;
  doctype: string;
  url: string;
  files?: {
    fileName: string;
    url: string;
  }[];
}

export interface PaymentInvoiceMap {
  docNumber?: string;
  id: string;
  createdDate: string;
  updatedDate: string;
  amountCleared: number;
  invoiceId: string;
  paymentTransactionId: string;
  invoice: InvoiceMap;
}

export interface InvoiceMap {
  id: string;
  createdDate: string;
  updatedDate: string;
  referenceInvoiceNumber: string;
  supTyp: string;
  invoiceDate: string;
  dueDate: string;
  invoiceAmount: number;
  paidAmount: number;
  irn: string;
  customerName: string;
  docType: string;
  gstin: any;
  docNumber: string;
  status: string;
  invoiceStatus: string;
  narration: any;
  workspaceId: string;
  inviteId: string;
  linkedWorkspacesId: string;
}

export interface ConfirmPaymentTransactionRequest {
  sellerWorkspaceId: string;
  buyerWorkspaceId: string;
  inviteId: string;
  createdBy: string;
  paymentDate: string;
  amountPaid: number;
  currencyCode: string;
  paymentMode: string;
  upiId?: string;
  paymentType: string;
  doctype: string;
  paymentRefCode?: string;
  instrumentNumber?: string;
  bankName?: string;
  bankAccountNumber?: string;
  bankReference?: string;
  cardType?: string;
  paymentProvider?: string;
  cardNumber?: string;
  narration?: string;
  invoices: {
    docNumber: string;
  }[];
}

export interface FieldState {
  key: string;
  label: string;
  type?: string;
  prefix?: string;
  value?: string;
  required?: boolean;
}

export interface FileUploadOutput {
  uri: string | null | ArrayBuffer;
  name: string;
  file: File;
  lastModified: number;
  size?: number;
  data?: any;
  type?: string;
}

export interface PaymentDetailsState {
  paymentDetails: FieldState[];
  paymentMedia: FileUploadOutput[];
  paymentInvoice: Invoice[];
  tempId?: string;
}

export type PaymentDetailValue = string | number | undefined;
export type PaymentDetailsMap = Record<string, PaymentDetailValue>;

export interface CreatePaymentTransactionRequest {
  sellerWorkspaceId: string;
  buyerWorkspaceId?: string;
  inviteId: string;
  paymentDate: string;
  amountPaid: number;
  allocatedAmount?: number;
  currencyCode?: string;
  paymentType?: string;
  paymentMode?: string;
  paymentProvider?: string;
  proofOfPayment?: string;
  approvedBy?: string;
  createdBy?: string;
  paymentRefCode?: string;
  bankName?: string;
  bankAccountNumber?: string;
  bankReference?: string;
  bankCode?: string;
  upiId?: string;
  cardType?: string;
  cardNumber?: string;
  paymentTransactionId?: string;
  isConfirmed?: boolean;
  instrumentNumber?: string;
  doctype: string;
  narration?: string;
  invoices?: {
    docNumber: string;
  }[];
}

export interface CreatePaymentTransactionResponse {
  id: string;
  createdDate: string;
  updatedDate: string;
  sellerWorkspaceId: string;
  buyerWorkspaceId: string;
  inviteId: string;
  paymentDate: string;
  amountPaid: number;
  allocatedAmount: number;
  currencyCode: string;
  status: string;
  subStatus: string | null;
  paymentType: string;
  paymentMode: string;
  paymentProvider: string | null;
  proofOfPayment: string | null;
  approvedBy: string | null;
  createdBy: string | null;
  paymentRefCode: string;
  instrumentNumber: string | null;
  instrumentDate: string | null;
  bankName: string | null;
  bankAccountNumber: string;
  bankReference: string;
  channel: string | null;
  cardNumber: string | null;
  cardNetwork: string | null;
  cardType: string | null;
  bankCode: string | null;
  upiId: string | null;
  referenceTransactionNumber: string | null;
  narration: string | null;
  erpOrderNumber: string | null;
  source: string;
  isAllocated: boolean;
  teamMemberId: string | null;
  cfaId: string | null;
  divisionId: string | null;
  clearingDate: string | null;
  statusCode: number;
  responseStatus: string;
}

export interface GetAccountsRequest {
  params: {
    sellerWorkspaceId: string;
    workspaceId: string;
  };
}
export interface GetAdminAccountsRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    workspaceId: string;
    paymentType: string;
    inviteId: string;
  };
}

export enum PaymentNotificationType {
  All = 'ALL',
  PaymentAdvice = 'GeneratePaymentNotification',
  PaymentReminders = 'PaymentReminders',
}

export interface GetAccountsReponse {
  bankAccounts: {
    id: string;
    bankName: string;
    accountNumber: string;
    accountHolderName: string;
    ifscCode: string;
    paymentNotificationtype: PaymentNotificationType;
  }[];
  upiAccounts: {
    id: string;
    upiId: string;
    mobileNo: string;
    upiAccountHolderName: string;
    qrCodeUrl?: string;
    paymentNotificationtype: PaymentNotificationType;
  }[];
}
export interface GetAdminAccountsResponse {
  bankAccounts: {
    id: string;
    bankName: string;
    accountNumber: string;
    accountHolderName: string;
    ifscCode: string;
    paymentNotificationtype: PaymentNotificationType;
  }[];
  upiAccounts: {
    id: string;
    upiId: string;
    mobileNo: string;
    upiAccountHolderName: string;
    qrCodeUrl?: string;
    paymentNotificationtype: PaymentNotificationType;
  }[];
}

export type PaymentAccountsMethodType =
  | ({ type: 'upi' } & GetAccountsReponse['upiAccounts'][number])
  | ({ type: 'bank' } & GetAccountsReponse['bankAccounts'][number]);

export type GenerateRazorpayLinkRequest = {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    amount: number;
    orderId: string;
    refOrderNumber: string;
    customer: {
      name: string;
      contact: string;
      id: string;
    };
    redirect_url: string;
  };
};

export type GenerateRazorpayLinkResponse = {
  accept_partial: boolean;
  amount: number;
  amount_paid: number;
  cancelled_at: number;
  created_at: number;
  currency: string;
  customer: {
    contact: string;
    name: string;
  };
  description: string;
  expire_by: number;
  expired_at: number;
  first_min_partial_amount: number;
  id: string;
  notes: {
    customerId: string;
  };
  notify: {
    email: boolean;
    sms: boolean;
    whatsapp: boolean;
  };
  payments: any;
  reference_id: string;
  reminder_enable: boolean;
  reminders: Array<any>;
  short_url: string;
  status: string;
  updated_at: number;
  upi_link: boolean;
  user_id: string;
  whatsapp_link: boolean;
};

export enum PaymentStatusEnum {
  PAID = 'P',
  SENT = 'SNT',
  CONFIRMED = 'CNF',
  DEFAULT = '',
}

export const PaymentStatusNames = {
  [PaymentStatusEnum.PAID]: 'Paid',
  [PaymentStatusEnum.SENT]: 'Sent',
  [PaymentStatusEnum.CONFIRMED]: 'Confirmed',
};
